/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsMiniPlay = ({ className }) => {
  return (
    <svg
      className={`heroicons-mini-play ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M6.29995 2.84058C5.3011 2.21087 4 2.92869 4 4.10947V15.8906C4 17.0714 5.3011 17.7892 6.29995 17.1595L15.6436 11.2689C16.577 10.6805 16.577 9.3196 15.6436 8.73115L6.29995 2.84058Z"
        fill="#7041F1"
      />
    </svg>
  );
};
